document.addEventListener('DOMContentLoaded', function () {
  var triggers = Array.from(document.querySelectorAll('.video-play-native[data-modal-video]'));
  if (!triggers.length) return;

  var container = document.createElement('div');
  container.className = 'video-modal__container video-modal__container--mp4';
  container.innerHTML =
    '<button class="video-modal__veil" aria-label="Close video"></button>' +
    '<div class="video-modal__content video-modal__content--mp4">' +
      '<div class="video-modal__vid-wrapper">' +
        '<video class="video-modal__mp4" playsinline controls></video>' +
      '</div>' +
    '</div>';
  document.body.appendChild(container);

  var veil = container.querySelector('.video-modal__veil');
  var video = container.querySelector('.video-modal__mp4');
  var activeInlineVideo = null;

  function openModal(btn) {
    var mp4 = btn.dataset.mp4 || '';
    var webm = btn.dataset.webm || '';

    video.innerHTML = '';
    if (mp4) {
      var srcMp4 = document.createElement('source');
      srcMp4.src = mp4;
      srcMp4.type = 'video/mp4';
      video.appendChild(srcMp4);
    }
    if (webm) {
      var srcWebm = document.createElement('source');
      srcWebm.src = webm;
      srcWebm.type = 'video/webm';
      video.appendChild(srcWebm);
    }

    // Pause the inline background video
    var inlineVideo = btn.closest('video-component');
    if (inlineVideo) {
      activeInlineVideo = inlineVideo.querySelector('video');
      if (activeInlineVideo) activeInlineVideo.pause();
    }

    video.load();
    video.play();
    container.classList.add('active');
  }

  function closeModal() {
    video.pause();
    video.currentTime = 0;
    container.classList.remove('active');

    // Resume the inline background video
    if (activeInlineVideo) {
      activeInlineVideo.play();
      activeInlineVideo = null;
    }
  }

  triggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal(btn);
    });
  });

  veil.addEventListener('click', closeModal);

  container.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeModal();
  });
});
